import { doc, setDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

// Generate a short, URL-safe ID
export const generateShortId = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < 8; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

// Create a shareable snapshot of a document
export const createShareableSnapshot = async (title, blocks, userId) => {
  const shareId = generateShortId();

  const snapshotData = {
    shareId,
    title: title || 'Heading',
    blocks: blocks.map(block => ({
      title: block.title,
      elements: block.elements.map(el => ({
        name: el.name,
        value: el.value
      }))
    })),
    createdBy: userId,
    createdAt: serverTimestamp(),
    viewCount: 0
  };

  await setDoc(doc(db, 'shared_snapshots', shareId), snapshotData);

  return shareId;
};

// Load a shared snapshot
export const loadSharedSnapshot = async (shareId) => {
  const docSnap = await getDoc(doc(db, 'shared_snapshots', shareId));

  if (docSnap.exists()) {
    return docSnap.data();
  }

  return null;
};

// Get the shareable URL
export const getShareableUrl = (shareId) => {
  return `${window.location.origin}/view/${shareId}`;
};
